import styled, {css} from "styled-components"
import Selector, {SelectorProps} from "@irati/ui/src/Selector"
import Slider from "@irati/ui/src/Slider"
import {Label} from "@irati/ui/src/Typography"

interface SelectorComponentProps extends SelectorProps {
  selected: boolean | undefined
  selectorBgColor: string
  iconBgColor: string
  svgData?: string
}

export const StyledSelector = styled(Selector)<SelectorComponentProps>`
  ${({theme, selected, selectorBgColor}) => css`
    background-color: ${selected ? selectorBgColor : theme.colors.utility.white};
    border: 2px solid ${selected ? selectorBgColor : theme.colors.primary2_50};
    width: 100%;
    height: 118px;
    margin-right: ${theme.spacing.two};

    &:hover {
      background-color: ${selectorBgColor};
      border-color: ${selectorBgColor};
      box-shadow: ${theme.shadows.low};
      color: ${theme.colors.utility.white};
      ${Label} {
        color: ${theme.colors.utility.white};
      }

      path {
        fill: ${theme.colors.primary2};
      }
    }

    &:focus {
      ${Label} {
        color: ${selected && theme.colors.utility.white};
      }
      background-color: ${selected && selectorBgColor};
      color: ${selected && theme.colors.utility.white};
      path {
        fill: ${theme.colors.primary2};
      }
    }
  `}
`

export const CategorySlider = styled(Slider)<SelectorComponentProps>`
  display: none !important;
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      display: block !important;
    `}
  `}
`
